// extracted by mini-css-extract-plugin
module.exports = {"root":"ticket-card_root__ORO_q","ticketLine":"ticket-card_ticketLine__6OaWK","ticketLineMobile":"ticket-card_ticketLineMobile__CcXBg"};